import React from 'react';
import UserProfile from '../../components/user/UserProfile';
import ActivityMonitorHOC from '../ActivityMonitorHOC';

const Profile = () => (
  <UserProfile />
);
export default ActivityMonitorHOC(Profile);